require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/es7.symbol.observable.js
// module id = XSlI
// module chunks = 15